<div
  [id]="id"
  class="advert {{type}}"
  aria-hidden="true">
  <h3>Advertisement</h3>
</div>
